import React, { useState } from "react";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";

import Arrow from "./Arrow";
import Generalsidebar from "./Generalsidebar";

function Forum() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [typedPost, setTypedPost] = useState(null);
  const allPosts = JSON.parse(sessionStorage.getItem("allPosts"))
    ? JSON.parse(sessionStorage.getItem("allPosts"))
    : [];

  // console.log('userInfo', userInfo);
  function handleArrowClick() {
    setShowSidebar(true);
  }

  const postCreated = allPosts.map((post) => (
    <div className="mb-4">
      <div className="bg-white md:mt-0 mt-4 flex items-center gap-2 py-2 px-4 relative rounded-md shadow-md">
        <img
          src="https://res.cloudinary.com/druryt8ny/image/upload/v1701272461/chap.png"
          alt="chap"
          className="w-6 h-6"
        />
        <p className="flex-1 text-green-700">@chap</p>
        <img
          src="https://res.cloudinary.com/druryt8ny/image/upload/v1701276484/message.png"
          alt="message"
          className="w-4 h-4"
        />
        <img
          src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273292/like.png"
          alt="like"
          className="w-4 h-4"
        />
      </div>
      <p className="bg-white -mt-4 -z-10 flex items-center gap-2 pt-8 pb-4 px-6 rounded-md shadow-md">
        {post}
      </p>
    </div>
  ));

  function addPost() {
    allPosts.unshift(typedPost);
    sessionStorage.setItem("allPosts", JSON.stringify(allPosts));
    setTypedPost(" ");
  }

  return (
    <div className="bg-[#D9D9D9]">
      <Navbar />
      <div onClick={handleArrowClick} className="absolute top-24 left-12 z-20">
        <Arrow />
      </div>
      <div className={showSidebar ? "show-sidebar" : "hidden"}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>

      <section className="px-4 mb-12">
        <div className="bg-white my-4 flex flex-wrap justify-between gap-1 py-2 px-2 rounded-md md:hidden">
          <div className="flex gap-1 items-center border-2 border-green-600 px-1 py-1 rounded-md">
            <img
              src="https://res.cloudinary.com/druryt8ny/image/upload/v1701272711/consultant.png"
              alt="consultant"
              className="w-4 h-4"
            />
            <p className="text-green-600 text-sm font-semibold">Consultants</p>
          </div>
          <div className="flex gap-1 items-center border-2 border-green-600 px-1 rounded-md">
            <img
              src="https://res.cloudinary.com/druryt8ny/image/upload/v1701275156/trending.png"
              alt="trending"
            />
            <p className="text-green-700 text-sm font-semibold">Trending</p>
          </div>
          <div className="flex gap-2 items-center border-2 border-green-600 pl-1 py-1 rounded-md">
            <img
              src="https://res.cloudinary.com/druryt8ny/image/upload/v1701275667/members.png"
              alt="members"
            />
            <p className="text-green-600 text-sm font-semibold">Members</p>
            <p className="text-white bg-[#4D732A] px-1 py-1 text-xs">2500</p>
          </div>
        </div>
        <div className="bg-white my-4 flex items-center gap-2 py-2 px-2 rounded-md md:hidden">
          <img
            src="https://res.cloudinary.com/druryt8ny/image/upload/v1701272461/chap.png"
            alt="chap"
            className="w-6 h-6"
          />
          <input
            type="text"
            className="focus:outline-none border border-green-100 rounded-md flex-1"
            onChange={(e) => setTypedPost(e.target.value)}
            value={typedPost}
          />
          <button
            className="text-white bg-[#295700] px-2 py-1 rounded-md text-xs"
            onClick={addPost}
          >
            Create Post
          </button>
        </div>
        <div className="md:grid md:grid-cols-7 justify-between gap-4 items-start md:py-8">
          <div className="md:order-2 md:col-start-3 md:col-end-6">
            <div className="bg-white mb-4 md:flex items-center gap-2 py-2 px-2 rounded-md hidden">
              <img
                src="https://res.cloudinary.com/druryt8ny/image/upload/v1701272461/chap.png"
                alt="chap"
                className="w-6 h-6"
              />
              <input
                type="text"
                className="focus:outline-none border border-green-100 rounded-md flex-1"
                onChange={(e) => setTypedPost(e.target.value)}
                value={typedPost}
              />
              <button
                className="text-white bg-[#295700] px-2 py-1 rounded-md text-xs"
                onClick={addPost}
              >
                Create Post
              </button>
            </div>
            <section id="top-post">
              {postCreated}
              <div>
                <div className="bg-white md:mt-0 mt-4 flex items-center gap-2 py-2 px-4 relative rounded-md shadow-md">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701272461/chap.png"
                    alt="chap"
                    className="w-6 h-6"
                  />
                  <p className="flex-1 text-green-700">@chap</p>
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701276484/message.png"
                    alt="message"
                    className="w-4 h-4"
                  />
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273292/like.png"
                    alt="like"
                    className="w-4 h-4"
                  />
                </div>
                <p className="bg-white -mt-4 -z-10 flex items-center gap-2 pt-8 pb-4 px-6 rounded-md shadow-md">
                  See In our hectic lives, the essence of rest and relaxation is
                  often overlooked. Yet, these moments of respite hold immense
                  value. Rest revitalizes our bodies, while relaxation
                  rejuvenates our minds. Together, they reduce stress, enhance
                  productivity, improve sleep, and promote overall well-being.
                  Simple practices like deep breathing, mindfulness, nature
                  walks, and quality sleep can easily be incorporated into daily
                  routines. By embracing these practices, we gift ourselves the
                  chance for better health and a more balanced life.
                </p>
              </div>
            </section>
            <div className="hidden md:block relative">
              <div className="px-[0.5px] bg-black w-0 absolute left-8 top-4 h-24 z-10" />
              <div className="py-[0.5px] bg-black w-12 absolute left-8 top-28 z-10" />
              <div className="flex mt-6 relative z-20">
                <div className="flex justify-between gap-4 bg-white rounded-md shadow-md">
                  <div className="flex gap-2 items-center bg-white pl-2 pr-8 py-1 rounded-tr-md rounded-md shadow-md">
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273171/jf.png"
                      alt="js"
                      className="w-4 h-4"
                    />
                    <p classs="flex-1">@JK</p>
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701276484/message.png"
                      alt="message"
                      className="w-4 h-4"
                    />
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273292/like.png"
                      alt="like"
                      className="w-4 h-4"
                    />
                  </div>
                  <p className="px-2 py-1">
                    Uncover stress' impact, manage through mindfulness and
                    prioritize well-being.
                  </p>
                </div>
              </div>
              <div className="flex mt-6 ml-12 relative z-20">
                <div className="flex justify-between gap-4 bg-white rounded-md shadow-md">
                  <div className="flex gap-2 items-center bg-white pl-2 pr-8 py-1 rounded-tr-md rounded-md shadow-md">
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273171/jf.png"
                      alt="js"
                      className="w-4 h-4"
                    />
                    <p classs="flex-1">@JK</p>
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701276484/message.png"
                      alt="message"
                      className="w-4 h-4"
                    />
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273292/like.png"
                      alt="like"
                      className="w-4 h-4"
                    />
                  </div>
                  <p className="px-2 py-1">
                    Sounds like the title of a book. If yes, who is the author ?
                  </p>
                </div>
              </div>
            </div>
            <div className="hidden md:block relative mt-8">
              <div className="px-[0.5px] bg-black w-0 absolute left-8 bottom-10 h-20" />
              <div className="py-[0.5px] bg-black w-12 absolute left-8 top-36" />
              <div className="flex mt-6 relative z-20">
                <div className="flex justify-between gap-4 bg-white rounded-md shadow-md">
                  <div className="flex gap-2 items-center bg-white pl-2 pr-16 py-1 rounded-tr-md rounded-md shadow-md">
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273171/jf.png"
                      alt="js"
                      className="w-4 h-4"
                    />
                    <p classs="flex-1">@JK</p>
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701276484/message.png"
                      alt="message"
                      className="w-4 h-4"
                    />
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273292/like.png"
                      alt="like"
                      className="w-4 h-4"
                    />
                  </div>
                  <p className="pl-1 pr-4 py-1">
                    Fatigue isn't just physical tiredness; it's a holistic
                    drain. It stems from various factors, including stress and
                    lifestyle. Prioritize rest, balance and seek help to break
                    free from its grip.
                  </p>
                </div>
              </div>
              <div className="flex mt-6 ml-12 relative z-20">
                <div className="flex justify-between gap-4 bg-white rounded-md shadow-md">
                  <div className="flex gap-2 items-center bg-white pl-2 pr-8 py-1 rounded-tr-md rounded-md shadow-md">
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273171/jf.png"
                      alt="js"
                      className="w-4 h-4"
                    />
                    <p classs="flex-1">@JK</p>
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701276484/message.png"
                      alt="message"
                      className="w-4 h-4"
                    />
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273292/like.png"
                      alt="like"
                      className="w-4 h-4"
                    />
                  </div>
                  <p className="px-2 py-1">
                    Sounds like the title of a book. If yes, who is the author ?
                  </p>
                </div>
              </div>
            </div>
            <div className="md:hidden">
              <div className="bg-white mt-4 flex items-center gap-2 py-4 px-2 relative rounded-md shadow-md">
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273171/jf.png"
                  alt="jf"
                  className="w-6 h-6"
                />
                <p className="flex-1 text-green-700">@JF</p>
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1701276484/message.png"
                  alt="message"
                  className="w-4 h-4"
                />
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273292/like.png"
                  alt="like"
                  className="w-4 h-4"
                />
              </div>
              <p className="bg-white -mt-4 -z-10 flex items-center gap-2 pt-8 pb-6 px-6 rounded-md shadow-md">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Non
                accusantium inventore modi dicta est vero quos vel et eligendi
                adipisci?
              </p>
              <div className="px-[0.5px] bg-black w-0 h-12 ml-20" />
              <div className="py-[0.5px] bg-black w-4 h-0 ml-20" />
              <div className="bg-white flex items-center gap-2 py-2 px-4 ml-24 -mt-6 relative rounded-md shadow-md">
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1701274316/mp.png"
                  alt="mp"
                  className="w-6 h-6"
                />
                <p className="flex-1 text-green-700">@Mp</p>
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1701276484/message.png"
                  alt="message"
                  className="w-4 h-4"
                />
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273292/like.png"
                  alt="like"
                  className="w-4 h-4"
                />
              </div>
              <p className="bg-white -mt-4 -z-10 flex items-center gap-2 pt-8 pb-2 px-4 ml-24 rounded-md shadow-md">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Non
                accusantium inventore modi dicta est vero quos vel et eligendi
                adipisci?
              </p>
              <div className="px-[0.5px] bg-black w-0 h-12 ml-28" />
              <div className="py-[0.4px] bg-black w-4 h-0 ml-28" />
              <div className="bg-white flex items-center gap-2 py-2 px-4 ml-32 -mt-6 relative rounded-md shadow-md">
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1701274316/mp.png"
                  alt="mp"
                  className="w-6 h-6"
                />
                <p className="flex-1 text-green-700">@Mp</p>
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1701276484/message.png"
                  alt="message"
                  className="w-4 h-4"
                />
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273292/like.png"
                  alt="like"
                  className="w-4 h-4"
                />
              </div>
              <p className="bg-white -mt-4 -z-10 flex items-center gap-2 pt-8 pb-2 px-4 ml-32 rounded-md shadow-md">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Non
                accusantium inventore modi dicta est vero quos vel et eligendi
                adipisci?
              </p>
            </div>
            {/*JUST ADDING THIS NOW*/}
            <div className="hidden md:block relative">
              <div className="relative z-20">
                <div className="bg-white hidden md:flex items-center gap-2 py-2 px-4 mt-8 relative rounded-md shadow-md">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701272461/chap.png"
                    alt="chap"
                    className="w-6 h-6"
                  />
                  <p className>@WJD</p>
                  <p className="font-semibold pl-4">
                    Understanding Depression: Navigating The Shadows
                  </p>
                </div>
                <p className="bg-white -mt-4 -mg-6 -z-10 flex items-center gap-2 pt-8 pb-2 px-4">
                  Depression, a complex mental health condition, goes beyond
                  temporary sadness. It affects mood, thoughts, and daily life.
                  Individuals with depression often experience persistent
                  feelings of hopelessness and emptiness, leading to a lack of
                  interest in activities and difficulty in functioning. While
                  its causes can vary, seeking professional help and support is
                  essential for managing depression. Through therapy,
                  medication, and a strong support network, those affected can
                  find a path toward healing and recovery.
                </p>
              </div>
              <div className="flex gap-2 shadow-md px-4 bg-white pt-8 pb-2 rounded-br-md rounded-bl-md  relative z-20">
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273292/like.png"
                  alt="like"
                  className="w-4 h-4"
                />
                <img
                  src="https://res.cloudinary.com/druryt8ny/image/upload/v1701276484/message.png"
                  alt="message"
                  className="w-4 h-4"
                />
              </div>
              <div className="px-[0.5px] bg-black w-0 absolute left-8 top-36 h-80 z-10" />
              <div className="py-[0.5px] bg-black w-12 absolute left-8 bottom-28 z-10" />
              <div className="py-[0.5px] bg-black w-12 absolute left-8 bottom-8 z-10" />
              <div className="flex ml-12 mt-8 relative z-20">
                <div className="flex justify-between gap-4 bg-white rounded-md shadow-md">
                  <div className="flex gap-2 items-center bg-white pl-2 pr-12 py-1 rounded-tr-md rounded-md shadow-md">
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273171/jf.png"
                      alt="jf"
                      className="w-4 h-4"
                    />
                    <p classs="flex-1">@user</p>
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701276484/message.png"
                      alt="message"
                      className="w-4 h-4"
                    />
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273292/like.png"
                      alt="like"
                      className="w-4 h-4"
                    />
                  </div>
                  <p className="pl-4 pr-6 py-2 w-full">
                    I can absolutely relate. I've been there before
                  </p>
                </div>
              </div>
              <div className="flex ml-12 mt-8  relative z-20">
                <div className="flex justify-between gap-4 bg-white rounded-md shadow-md">
                  <div className="flex gap-2 items-center bg-white pl-2 pr-6 py-1 rounded-tr-md rounded-md shadow-md">
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273171/jf.png"
                      alt="js"
                      className="w-4 h-4"
                    />
                    <p classs="flex-1">@user</p>
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701276484/message.png"
                      alt="message"
                      className="w-4 h-4"
                    />
                    <img
                      src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273292/like.png"
                      alt="like"
                      className="w-4 h-4"
                    />
                  </div>
                  <p className="px-2 py-1">
                    When depression creeps in, you gradually start losing it.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="md:order-3 md:mt-0 md:flex flex-col md:col-start-6 md:col-end-8">
            <div className="hidden md:flex justify-between px-4 py-[6px] bg-white rounded-md mb-1">
              <p>Chap</p>
              <img
                src="https://res.cloudinary.com/druryt8ny/image/upload/v1701272461/chap.png"
                alt="chap"
                className="w-6 h-6"
              />
            </div>
            <div className="bg-white mt-8 md:mt-2 p-4 rounded-md">
              <h2 className="text-center text-xl mb-4">Consultants</h2>
              <div className="grid grid-cols-3 md:grid-cols-3 gap-2 md:justify-around">
                <div className="flex flex-col justify-center items-center gap-2">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701272126/Agu.jpg"
                    alt=""
                    className="w-20 h-20 rounded-full"
                  />
                  <p>Agu</p>
                </div>
                <div className="flex flex-col justify-center items-center gap-2">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701274851/Shomope.jpg"
                    alt=""
                    className="w-20 h-20 rounded-full"
                  />
                  <p>Aisha</p>
                </div>
                <div className="flex flex-col justify-center items-center gap-2">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1700513418/sue40dii2kkn1slpmlgb.jpg"
                    alt=""
                    className="w-20 h-20 rounded-full"
                  />
                  <p>Wajud</p>
                </div>
                <div className="flex flex-col justify-center items-center gap-2">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273235/Leks.jpg"
                    alt=""
                    className="w-20 h-20 rounded-full"
                  />
                  <p>Salem</p>
                </div>
                <div className="flex flex-col justify-center items-center gap-2">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701274364/Peace.jpg"
                    alt=""
                    className="w-20 h-20 rounded-full"
                  />
                  <p>Peace</p>
                </div>
                <div className="flex flex-col justify-center items-center gap-2">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701274579/Qozeem.jpg"
                    alt=""
                    className="w-20 h-20 rounded-full"
                  />
                  <p>Qozeem</p>
                </div>
              </div>
            </div>
            <div className="py-2 hidden md:block bg-white mt-4 rounded-md">
              <p className="px-4 py-[2px]">3000 Members</p>
              <div className="w-full h-[1px] bg-green-50" />
              <div className="pt-2 pb-4 px-4 flex flex-col gap-4 justify-center">
                <div className="flex gap-4 items-center">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701275079/tj.png"
                    alt="tj"
                    className="w-6 h-6"
                  />
                  <p>TJ</p>
                </div>
                <div className="flex gap-4 items-center">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273023/ht.png"
                    alt="ht"
                    className="w-6 h-6"
                  />
                  <p>HT</p>
                </div>
                <div className="flex gap-4 items-center">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701274209/mm.png"
                    alt="mm"
                    className="w-6 h-6"
                  />
                  <p>MM</p>
                </div>
                <div className="flex gap-4 items-center">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701274889/sj.png"
                    alt="sj"
                    className="w-6 h-6"
                  />
                  <p>SJ</p>
                </div>
                <div className="flex gap-4 items-center">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273023/ht.png"
                    alt="ht"
                    className="w-6 h-6"
                  />
                  <p>AQ</p>
                </div>
                <div className="flex gap-4 items-center">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701272816/ffk.png"
                    alt="ffk"
                    className="w-6 h-6"
                  />
                  <p>FFK</p>
                </div>
                <div className="flex gap-4 items-center">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273171/jf.png"
                    alt="bat"
                    className="w-6 h-6"
                  />
                  <p>BAT</p>
                </div>
                <div className="flex gap-4 items-center">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273023/ht.png"
                    alt="ht"
                    className="w-6 h-6"
                  />
                  <p>RP</p>
                </div>
                <div className="flex gap-4 items-center">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701272816/ffk.png"
                    alt="na"
                    className="w-6 h-6"
                  />
                  <p>NA</p>
                </div>
                <div className="flex gap-4 items-center">
                  <img
                    src="https://res.cloudinary.com/druryt8ny/image/upload/v1701272498/che.png"
                    alt="che"
                    className="w-6 h-6 rounded-full"
                  />
                  <p>Che</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white px-4 md:pr-8 pb-12 mt-8 rounded-md md:col-start-1 md:col-end-3 md:mt-0 md:order-1">
            <h2 className="text-center md:text-left font-semibold text-green-700 pb-8 md:pb-6 pt-4">
              Trending Topics
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-1 gap-x-4 gap-y-8">
              <div className="flex gap-2 justify-start w-fit">
                <div className="relative py-1">
                  <div className="absolute top-2 h-10 w-[98%] border-l-2 border-b-2 border-l-green-700 border-b-green-700 rounded-sm p-2"></div>
                  <p className="ml-1 text-xl text-green-700 py-1 px-[12px] bg-white border-2 border-green-700 font-semibold rounded-sm">
                    1
                  </p>
                </div>
                <div className="translate-y-4">
                  <h3 className="font-semibold text-lg">#rest</h3>
                  <p className="text-xs font-semibold">
                    2,500 Posted by this tag
                  </p>
                </div>
              </div>
              <div className="flex gap-2 justify-start">
                <div className="relative py-1">
                  <div className="absolute top-2 h-10 w-[98%] border-l-2 border-b-2 border-l-green-700 border-b-green-700 rounded-sm p-2"></div>
                  <p className="ml-1 text-xl text-green-700 py-1 px-[12px] bg-white border-2 border-green-700 font-semibold rounded-sm">
                    2
                  </p>
                </div>
                <div className="translate-y-2">
                  <h3 className="text-lg -mb-2">#stress</h3>
                  <div className="text-xs font-semibold">
                    <p>
                      2,300 Posted <span className="font-bold text-2xl">.</span>{" "}
                      Trending
                    </p>
                    <p />
                  </div>
                </div>
              </div>
              <div className="flex md:hidden gap-2 justify-start">
                <div className="relative py-1">
                  <div className="absolute top-2 h-10 w-[98%] border-l-2 border-b-2 border-l-green-700 border-b-green-700 rounded-sm p-2"></div>
                  <p className="ml-1 text-xl text-green-700 py-1 px-[12px] bg-white border-2 border-green-700 font-semibold rounded-sm">
                    2
                  </p>
                </div>
                <div className="translate-y-4">
                  <h3 className="text-lg -mb-[10px]">#stress</h3>
                  <div className="text-xs font-semibold">
                    <p>
                      2,300 Posted <span className="font-bold text-2xl">.</span>{" "}
                      Trending
                    </p>
                    <p />
                  </div>
                </div>
              </div>
              <div className="flex gap-2 justify-start">
                <div className="relative py-1">
                  <div className="absolute top-2 h-10 w-[98%] border-l-2 border-b-2 border-l-green-700 border-b-green-700 rounded-sm p-2"></div>
                  <p className="ml-1 text-xl text-green-700 py-1 px-[12px] bg-white border-2 border-green-700 font-semibold rounded-sm">
                    3
                  </p>
                </div>
                <div className="translate-y-4">
                  <h3 className="text-lg -mb-[10px]">#depression</h3>
                  <div className="text-xs font-semibold">
                    <p>
                      2,000 Posted <span className="font-bold text-2xl">.</span>{" "}
                      Trending
                    </p>
                    <p />
                  </div>
                </div>
              </div>
              <div className="flex md:hidden gap-2 justify-start">
                <div className="relative py-1">
                  <div className="absolute top-2 h-10 w-[98%] border-l-2 border-b-2 border-l-green-700 border-b-green-700 rounded-sm p-2"></div>
                  <p className="ml-1 text-xl text-green-700 py-1 px-[12px] bg-white border-2 border-green-700 font-semibold rounded-sm">
                    3
                  </p>
                </div>
                <div className="translate-y-4">
                  <h3 className="text-lg -mb-[10px]">#depression</h3>
                  <div className="text-xs font-semibold">
                    <p>
                      2,000 Posted <span className="font-bold text-2xl">.</span>{" "}
                      Trending
                    </p>
                    <p />
                  </div>
                </div>
              </div>
              <div className="flex gap-2 justify-start">
                <div className="relative py-1">
                  <div className="absolute top-2 h-10 w-[98%] border-l-2 border-b-2 border-l-green-700 border-b-green-700 rounded-sm p-2"></div>
                  <p className="ml-1 text-xl text-green-700 py-1 px-[12px] bg-white border-2 border-green-700 font-semibold rounded-sm">
                    4
                  </p>
                </div>
                <div className="translate-y-4">
                  <h3 className="text-lg -mb-[10px]">#anxiety</h3>
                  <div className="text-xs font-semibold">
                    <p>
                      1,600 Posted <span className="font-bold text-2xl">.</span>{" "}
                      Trending
                    </p>
                    <p />
                  </div>
                </div>
              </div>
              <div className="flex md:hidden gap-2 justify-start">
                <div className="relative py-1">
                  <div className="absolute top-2 h-10 w-[98%] border-l-2 border-b-2 border-l-green-700 border-b-green-700 rounded-sm p-2"></div>
                  <p className="ml-1 text-xl text-green-700 py-1 px-[12px] bg-white border-2 border-green-700 font-semibold rounded-sm">
                    4
                  </p>
                </div>
                <div className="translate-y-4">
                  <h3 className="text-lg">#anxiety</h3>
                  <div className="text-xs font-semibold">
                    <p>1,600 Posted by this tag</p>
                  </div>
                </div>
              </div>
              <div className="flex gap-2 justify-start">
                <div className="relative py-1">
                  <div className="absolute top-2 h-10 w-[98%] border-l-2 border-b-2 border-l-green-700 border-b-green-700 rounded-sm p-2"></div>
                  <p className="ml-1 text-xl text-green-700 py-1 px-[12px] bg-white border-2 border-green-700 font-semibold rounded-sm">
                    5
                  </p>
                </div>
                <div className="translate-y-4">
                  <h3 className="text-lg -mb-[10px]">#wellbeing</h3>
                  <div className="text-xs font-semibold">
                    <p>
                      1,100 <span className="font-bold text-2xl">.</span>{" "}
                      Trending
                    </p>
                    <p />
                  </div>
                </div>
              </div>
              <div className="flex md:hidden gap-2 justify-start">
                <div className="relative py-1">
                  <div className="absolute top-2 h-10 w-[98%] border-l-2 border-b-2 border-l-green-700 border-b-green-700 rounded-sm p-2"></div>
                  <p className="ml-1 text-xl text-green-700 py-1 px-[12px] bg-white border-2 border-green-700 font-semibold rounded-sm">
                    5
                  </p>
                </div>
                <div className="translate-y-4">
                  <h3 className="text-lg -mb-[10px]">#wellbeing</h3>
                  <div className="text-xs font-semibold">
                    <p>
                      1,100 <span className="font-bold text-2xl">.</span>{" "}
                      Trending
                    </p>
                    <p />
                  </div>
                </div>
              </div>
              <div className="flex gap-2 justify-start">
                <div className="relative py-1">
                  <div className="absolute top-2 h-10 w-[98%] border-l-2 border-b-2 border-l-green-700 border-b-green-700 rounded-sm p-2"></div>
                  <p className="ml-1 text-xl text-green-700 py-1 px-[12px] bg-white border-2 border-green-700 font-semibold rounded-sm">
                    6
                  </p>
                </div>
                <div className="translate-y-4">
                  <h3 className="text-lg">#fatigue</h3>
                  <p className="text-xs font-semibold">
                    700 Posted by this tag
                  </p>
                </div>
              </div>
              <div className="flex md:hidden gap-2 justify-start">
                <div className="relative py-1">
                  <div className="absolute top-2 h-10 w-[98%] border-l-2 border-b-2 border-l-green-700 border-b-green-700 rounded-sm p-2"></div>
                  <p className="ml-1 text-xl text-green-700 py-1 px-[12px] bg-white border-2 border-green-700 font-semibold rounded-sm">
                    6
                  </p>
                </div>
                <div className="translate-y-4">
                  <h3 className="text-lg">#fatigue</h3>
                  <p className="text-xs font-semibold">
                    700 Posted by this tag
                  </p>
                </div>
              </div>
              <div className="flex md:hidden gap-2 justify-start">
                <div className="relative py-1">
                  <div className="absolute top-2 h-10 w-[98%] border-l-2 border-b-2 border-l-green-700 border-b-green-700 rounded-sm p-2"></div>
                  <p className="ml-1 text-xl text-green-700 py-1 px-[12px] bg-white border-2 border-green-700 font-semibold rounded-sm">
                    6
                  </p>
                </div>
                <div className="translate-y-4">
                  <h3 className="text-lg">#fatigue</h3>
                  <p className="text-xs font-semibold">
                    700 Posted by this tag
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white mt-12 flex items-center gap-2 py-2 px-4 relative rounded-md shadow-md md:hidden">
          <img
            src="https://res.cloudinary.com/druryt8ny/image/upload/v1701272461/chap.png"
            alt="chap"
            className="w-6 h-6"
          />
          <p className="flex-1 text-green-700">@chap</p>
          <img
            src="https://res.cloudinary.com/druryt8ny/image/upload/v1701276484/message.png"
            alt="message"
            className="w-4 h-4"
          />
          <img
            src="https://res.cloudinary.com/druryt8ny/image/upload/v1701273292/like.png"
            alt="like"
            className="w-4 h-4"
          />
        </div>
        <p className="bg-white -mt-4 -z-10 flex items-center gap-2 pt-8 pb-2 px-4 rounded-md shadow-md md:hidden">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Non
          accusantium inventore modi dicta est vero quos vel et eligendi
          adipisci?
        </p>
      </section>

      <Footer />
    </div>
  );
}

export default Forum;
